// history.js

//use memory history for instant app but could just as easily switch to browser history for webapp use
import {
	createMemoryHistory
} from 'history'

export const history = createMemoryHistory();

// import {
// 	createBrowserHistory,
// } from 'history'

// export const history = createBrowserHistory();
